/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Input_PlaceholderInputs */

const es_user_input_placeholder = /** @type {(inputs: User_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar usuario`)
};

const en_user_input_placeholder = /** @type {(inputs: User_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select user`)
};

/**
* | output |
* | --- |
* | "Select user" |
*
* @param {User_Input_PlaceholderInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_input_placeholder = /** @type {((inputs?: User_Input_PlaceholderInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Input_PlaceholderInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_input_placeholder(inputs)
	return en_user_input_placeholder(inputs)
});
export { user_input_placeholder as "user_input.placeholder" }